// External Dependencies:
import React from 'react'

// Internal Dependencies:
import Page from 'church-theme-library/pages/Page'

class SpeakerLayout extends React.Component {
	render() {
		return (
			<Page { ...this.props } />
		)
	}
}

export default SpeakerLayout
